"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "JwtRefresher", {
  enumerable: true,
  get: function get() {
    return _JwtRefresher.default;
  }
});
Object.defineProperty(exports, "SignInErrorCodes", {
  enumerable: true,
  get: function get() {
    return _signInErrorCodes.default;
  }
});
Object.defineProperty(exports, "USER_LOGOUT", {
  enumerable: true,
  get: function get() {
    return _signInErrorCodes.USER_LOGOUT;
  }
});
exports.authReducers = void 0;
Object.defineProperty(exports, "base64Url", {
  enumerable: true,
  get: function get() {
    return _base64Url.default;
  }
});
Object.defineProperty(exports, "clearJwtAndSessApiCookies", {
  enumerable: true,
  get: function get() {
    return _clearJwtAndSessApiCookies.default;
  }
});
Object.defineProperty(exports, "fetch", {
  enumerable: true,
  get: function get() {
    return _fetchRetry.default;
  }
});
Object.defineProperty(exports, "getCookieDomain", {
  enumerable: true,
  get: function get() {
    return _cookieDomain.default;
  }
});
Object.defineProperty(exports, "getSigninUrl", {
  enumerable: true,
  get: function get() {
    return _getSigninUrl.default;
  }
});
Object.defineProperty(exports, "isXssSafe", {
  enumerable: true,
  get: function get() {
    return _isXssSafe.default;
  }
});
Object.defineProperty(exports, "logger", {
  enumerable: true,
  get: function get() {
    return _logger.default;
  }
});
Object.defineProperty(exports, "logoutUser", {
  enumerable: true,
  get: function get() {
    return _logoutUser.default;
  }
});
Object.defineProperty(exports, "redirectToSignin", {
  enumerable: true,
  get: function get() {
    return _redirectToSignin.default;
  }
});
Object.defineProperty(exports, "setJwtAndSessApiCookies", {
  enumerable: true,
  get: function get() {
    return _setJwtAndSessApiCookies.default;
  }
});
var authReducers = _interopRequireWildcard(require("./modules"));
exports.authReducers = authReducers;
var _getSigninUrl = _interopRequireDefault(require("./util/getSigninUrl"));
var _redirectToSignin = _interopRequireDefault(require("./util/redirectToSignin"));
var _logoutUser = _interopRequireDefault(require("./util/logoutUser"));
var _isXssSafe = _interopRequireDefault(require("./util/isXssSafe"));
var _signInErrorCodes = _interopRequireWildcard(require("./util/signInErrorCodes"));
var _cookieDomain = _interopRequireDefault(require("./util/cookieDomain"));
var _logger = _interopRequireDefault(require("./util/logger"));
var _fetchRetry = _interopRequireDefault(require("./util/fetch-retry"));
var _JwtRefresher = _interopRequireDefault(require("./components/session/JwtRefresher"));
var _base64Url = _interopRequireDefault(require("./util/base64Url"));
var _setJwtAndSessApiCookies = _interopRequireDefault(require("./util/setJwtAndSessApiCookies"));
var _clearJwtAndSessApiCookies = _interopRequireDefault(require("./util/clearJwtAndSessApiCookies"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }